const actions = {
    page_title: 'Actions',
    title: 'Actions',
    subtitle: '在身份验证流程的特定节点运行自定义代码，以扩展 Logto 的行为。',
    status: {
        not_configured: '未配置',
        configured: '已配置',
        enabled: '已启用',
        disabled: '已停用',
    },
    types: {
        post_first_factor_verification: {
            name: '首个身份验证因素验证后',
            description: '在登录期间本地密码验证失败后运行自定义逻辑。',
        },
        post_sign_in: {
            name: '登录后',
            description: '在用户成功登录后运行自定义逻辑。',
        },
    },
    data_source_tab: '数据源',
    test_tab: '测试上下文',
    settings_tab: '设置',
    event_data: {
        title: '事件载荷',
        subtitle: '使用 `event` 输入参数获取身份验证事件数据。',
    },
    result_data: {
        title: '操作结果',
        subtitle: '返回 Logto 可理解的结果对象，以适配此操作类型。',
    },
    environment_variables: {
        title: '设置环境变量',
        subtitle: '使用环境变量存储敏感信息。',
        input_field_title: '添加环境变量',
        sample_code: '在操作处理程序中访问环境变量。示例：',
    },
    fetch_external_data: {
        title: '获取外部数据',
        subtitle: '在操作脚本中调用外部 API。',
        description: '使用 `fetch` 函数调用外部 API，并将数据包含在操作结果中。示例：',
    },
    settings: {
        title: '设置',
        subtitle: '控制操作是否启用，以及运行时错误的处理方式。',
        enabled: {
            title: '启用操作',
            description: '在身份验证事件触发时运行此脚本。',
        },
        on_execution_error: {
            title: '脚本出错时',
            description: '选择脚本运行失败时 Logto 的行为。',
            block: '阻止身份验证流程',
            allow: '允许身份验证流程继续',
            post_first_factor_description: '当此脚本失败时，Logto 始终拒绝无效凭证，以确保无法绕过密码验证。',
        },
    },
    test_context: {
        subtitle: '调整运行测试时使用的模拟事件载荷。',
        input_field_title: '事件示例 JSON',
    },
    script: {
        title: '脚本',
        restore: '恢复默认值',
        restored: '已恢复',
    },
    tester: {
        run_button: '运行测试',
        result_title: '测试结果',
    },
    form_error: {
        invalid_json: '无效的 JSON 格式',
    },
    sandbox_and_security_warning: {
        title: '脚本以服务器权限运行',
        description: '在自托管的 Logto 中，此脚本与 Logto 本身运行在相同环境中：它可以读取服务器环境变量并访问你的内网服务。它没有沙箱隔离。请仅向你信任可访问服务器的人开放此页面。此操作仅在本地密码验证失败后运行——只有在独立验证提交的密码后，才能返回 `passwordVerified: true`。通过此操作创建的用户会绕过仅适用于注册的限制，包括邮箱黑名单、仅 SSO 域名、禁用注册模式，以及注册必填资料检查。对已有用户的资料和密码写入也会在 MFA 完成前发生。',
    },
    sandbox_warning: {
        title: '脚本以服务器权限运行',
        description: '在自托管的 Logto 中，此脚本与 Logto 本身运行在相同环境中：它可以读取服务器环境变量并访问你的内网服务。它没有沙箱隔离。请仅向你信任可访问服务器的人开放此页面。',
    },
    security_warning: {
        title: '安全警告',
        description: '此操作仅在本地密码验证失败后运行。只有在独立验证提交的密码后，才能返回 `passwordVerified: true`。通过此操作创建的用户会绕过仅适用于注册的限制，包括邮箱黑名单、仅 SSO 域名、禁用注册模式，以及注册必填资料检查。对已有用户的资料和密码写入也会在 MFA 完成前发生。',
    },
    delete_modal_title: '删除操作',
    delete_modal_content: '确定要删除此操作吗？身份验证流程将不再运行此脚本。',
    deleted: '操作已删除',
    created: '操作已创建',
    saved: '操作已保存',
};
export default Object.freeze(actions);
